module.exports = __webpack_public_path__ + "static/butterfly.e3c7f557.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/libraries/butterfly.jpg
// module id = 132
// module chunks = 29745001925707 248600712657012